export default function encodeState(state) {
  const jsonString = JSON.stringify({
    redirect_to: `${window.location.origin}${window.location.pathname}`,
    anon_id: window.__GD_ANONYMOUS_ID || null,
    ...state
  });
  const base64 = btoa(jsonString);
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
